// @see mylw-uat2.nexcess-internal.workers.dev
import uatTemplate from './uat';
import type { AppConfigI } from './example';

const uat2: AppConfigI = {
	...uatTemplate,
	openId: {
		...uatTemplate.openId,
		client_id: 'mylw-uat2-cp',
	},
};

export default uat2;
